import { getDefaultDependent } from "."

export default function resetDependentFields(user, setFieldValue, setTouched) {
	const dependent = getDefaultDependent(user)

	const touched = {
		dependent: {
			firstName: false,
			lastName: false,
			relationship: false,
			dateOfBirth: false,
			gender: false,
			addressLine1: false,
			city: false,
			state: false,
			zip: false
		}
	}

	setFieldValue("dependent", dependent)
	setTouched(touched)
}
